import React from "react";
import { ProjectsTableTitleCell } from "../partials/ProjectsTable/cells/ProjectsTableTitleCell";

export const renderTitle = (project) => {
  return <ProjectsTableTitleCell project={project} />;
};
